import { produce } from 'immer';

import { FORM_BUNDLE_ACTION_TYPE, FORM_BUNDLE_FORM_ACTION_TYPE } from 'store/forms/actions';
import { RESET_STATE } from 'store/global/actions';

const initialState = {};

const formBundlesReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case FORM_BUNDLE_ACTION_TYPE.GET_BUNDLES:
        return payload;

      case FORM_BUNDLE_ACTION_TYPE.EDIT_BUNDLE:
      case FORM_BUNDLE_ACTION_TYPE.CREATE_BUNDLE:
        draft[payload.formBundleId] = payload;
        break;

      case FORM_BUNDLE_ACTION_TYPE.DELETE_BUNDLE:
        delete draft[payload];
        break;

      case FORM_BUNDLE_ACTION_TYPE.GET_BUNDLE_HISTORY:
        draft[meta.formBundleId].history = payload;
        break;

      case FORM_BUNDLE_FORM_ACTION_TYPE.EDIT_FORM:
      case FORM_BUNDLE_FORM_ACTION_TYPE.DELETE_FORM:
      case FORM_BUNDLE_FORM_ACTION_TYPE.CREATE_FORM:
        draft[payload.formBundleId].version += 1;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default formBundlesReducer;
